import type { Intervention } from "@/types/bexSupport";
import type { InterventionState } from "@/types/store";
import type { MutationTree } from "vuex";

// Mutations
export const LOAD_INTERVENTIONS = "LOAD_INTERVENTIONS";
export const LOAD_INTERVENTIONS_SUCCESS = "LOAD_INTERVENTIONS_SUCCESS";
export const LOAD_INTERVENTIONS_FAILURE = "LOAD_INTERVENTIONS_FAILURE";

export const LOAD_INTERVENTION = "LOAD_INTERVENTION";
export const LOAD_INTERVENTIONS_ALL_SUCCESS = "LOAD_INTERVENTIONS_ALL_SUCCESS";
export const LOAD_INTERVENTION_SUCCESS = "LOAD_INTERVENTION_SUCCESS";
export const LOAD_INTERVENTION_FAILURE = "LOAD_INTERVENTION_FAILURE";

export const ADD_INTERVENTION = "ADD_INTERVENTION";
export const ADD_INTERVENTION_SUCCESS = "ADD_INTERVENTION_SUCCESS";
export const ADD_INTERVENTION_FAILURE = "ADD_INTERVENTION_FAILURE";

export const DELETE_INTERVENTION = "DELETE_INTERVENTION";
export const DELETE_INTERVENTION_SUCCESS = "DELETE_INTERVENTION_SUCCESS";
export const DELETE_INTERVENTION_FAILURE = "DELETE_INTERVENTION_FAILURE";

export const UPDATE_INTERVENTION = "UPDATE_INTERVENTION";
export const UPDATE_INTERVENTION_SUCCESS = "UPDATE_INTERVENTION_SUCCESS";
export const UPDATE_INTERVENTION_FAILURE = "UPDATE_INTERVENTION_FAILURE";

export const mutations: MutationTree<InterventionState> = {
  [LOAD_INTERVENTIONS](state: InterventionState) {
    state.interventions = {
      ...state.interventions,
      loading: true,
      error: null,
    };
  },
  [LOAD_INTERVENTIONS_SUCCESS](state: InterventionState, data: any) {
    state.interventions = {
      ...state.interventions,
      data: data.data,
      loading: false,
      error: null,
      count: data.total_count,
    };
  },
  [LOAD_INTERVENTIONS_ALL_SUCCESS](state: InterventionState, data: any) {
    state.interventions = {
      ...state.interventions,
      data: data.data,
      loading: false,
      error: null,
      count: data.total_count,
      data_completed: data.data_completed,
      count_completed: data.count_completed,
    };
  },
  [LOAD_INTERVENTIONS_FAILURE](state: InterventionState, error: string) {
    state.interventions = { ...state.interventions, loading: false, error };
  },
  [ADD_INTERVENTION](state: InterventionState) {
    state.interventions = {
      ...state.interventions,
      loading: true,
      error: null,
    };
  },
  [ADD_INTERVENTION_SUCCESS](
    state: InterventionState,
    intervention: Intervention,
  ) {
    state.interventions = {
      ...state.interventions,
      data: [...state.interventions.data, intervention],
      loading: false,
      error: null,
    };
  },
  [ADD_INTERVENTION_FAILURE](state: InterventionState, error: string) {
    state.interventions = { ...state.interventions, loading: false, error };
  },
  [UPDATE_INTERVENTION](state: InterventionState) {
    state.interventions = {
      ...state.interventions,
      loading: true,
      error: null,
    };
  },
  [UPDATE_INTERVENTION_SUCCESS](state: InterventionState, intervention: any) {
    state.interventions.loading = false;
    state.interventions.error = null;
    const index = state.interventions.data.findIndex(
      (item: any) => item.id === intervention.id,
    );
    if (index !== -1) state.interventions.data[index] = intervention;
  },
  [UPDATE_INTERVENTION_FAILURE](state: InterventionState, error: string) {
    state.interventions = { ...state.interventions, loading: false, error };
  },

  // LOAD_ONE_EVENT
  [LOAD_INTERVENTION](state: InterventionState) {
    state.intervention = { ...state.intervention, loading: true, error: null };
  },
  [LOAD_INTERVENTION_SUCCESS](state: InterventionState, event: Intervention) {
    state.intervention = {
      data: event,
      loading: false,
      error: null,
    };
  },
  [LOAD_INTERVENTION_FAILURE](state: InterventionState, error: string) {
    state.intervention = {
      ...state.intervention,
      loading: false,
      error: error,
    };
  },

  [DELETE_INTERVENTION](state: InterventionState) {
    state.interventions = {
      ...state.interventions,
      loading: true,
      error: null,
    };
  },
  [DELETE_INTERVENTION_SUCCESS](state: InterventionState, id: any) {
    state.interventions = {
      ...state.interventions,
      data: state.interventions.data.filter(
        (sc: Intervention) => sc.bsInterventionId !== id,
      ),
      loading: false,
      error: null,
      count: state.interventions.count - 1,
    };
  },
  [DELETE_INTERVENTION_FAILURE](state: InterventionState, error: string) {
    state.interventions = {
      ...state.interventions,
      loading: false,
      error: error,
    };
  },
};
